import { styled, Typography } from '@mui/material'
import { preventForwardProps } from 'utils/styledUtils'
import { ITagButton } from './types'

export const TagsFilterContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  flexWrap: 'wrap',
}))

export const TagButton = styled(
  Typography,
  preventForwardProps(['activeTag']),
)<ITagButton>(({ theme, activeTag }) => ({
  ...theme.typography.body2,
  display: 'flex',
  height: '32px',
  padding: theme.spacing(0.5, 2),
  justifyContent: 'center',
  alignItems: 'center',
  background: activeTag ? 'rgba(0, 156, 216, 0.35)' : 'rgba(255, 255, 255, 0.08)',
  borderRadius: '16px',
  cursor: 'pointer',
  '&:hover': {
    background: 'rgba(0, 156, 216, 0.35)',
  },
}))
